import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: "#FD5400", // #00ACC1 blue
            secondary: "#f45f06", // #E53935
            accent: colors.indigo.base, // #3F51B5
            bg: colors.grey.darken4 // #212121
          },
        }
      }
});
